import React, { Component } from 'react';
import '../../App.css';

import { Link } from 'react-router-dom'

class bannerVideo extends Component {
  constructor(props){
    super(props)
  }

  static defaultProps = {
    title:'',
    description:'',
    video:'',
    linkto:''
  }

  render() {
    return (
      <div className="banner-video">
        <video controls={false} autoPlay muted loop>
            <source src={this.props.video} type="video/mp4"/>
            Your browser does not support the video tag.
        </video>
        <span>{this.props.title}</span>
        <p>{this.props.description}<br/><br/><br/>
          <Link to={"/en/"+this.props.linkto}>KNOW MORE</Link>
        </p>
      </div>
    );
  }
}

export default bannerVideo;


// WEBPACK FOOTER //
// ./src/components/en-home/banner-video.js